// extracted by mini-css-extract-plugin
export default {"loaderContainer":"CircleLoader-module__loaderContainer___sc9po","circleLoader":"CircleLoader-module__circleLoader___TVPjQ","spin":"CircleLoader-module__spin____zBxl"};